import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getOptimizedImageUrl } from '../lib/utils';

export default function ProjectCard({ project }) {
  const { title, category, image, project_slug } = project;
  const displayTitle = title.da || title;
  const displayCategory = category.da || category;
  const imageUrl = Array.isArray(image) ? image[0] : image;
  const optimizedImageUrl = getOptimizedImageUrl(imageUrl, { width: 600, quality: 80 });

  return (
    <div className="group bg-white border border-slate-100 overflow-hidden">
      <figure className="aspect-[4/3] overflow-hidden relative m-0">
        <img
          src={optimizedImageUrl}
          alt={`Skruefundament referenceprojekt: ${displayTitle} (${displayCategory})`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-4 left-4 bg-slate-900 text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 z-10">
          {displayCategory}
        </div>
        <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-slate-950/80 via-slate-950/40 to-transparent p-3 text-white text-xs opacity-90 truncate">
          {displayTitle} – Professionelt skruefundament
        </figcaption>
      </figure>
      <div className="p-8">
        <h3 className="text-2xl font-bold uppercase tracking-tight mb-4 group-hover:text-slate-700 transition-colors">
          {displayTitle}
        </h3>
        <Link
          to={`/projekter#project-${project.id}`}
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-900 hover:gap-4 transition-all"
        >
          Se projekt <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
